module.exports = __webpack_public_path__ + "static/media/maketeam.9e228513.wav";